import React from "react";

import { TransactionTableSkeletonLoader } from "./TransactionTableSkeletonLoader";

export function TableSkeletonLoader() {
	return (
		<>
			<div className="skeleton__table table table--bordered table--shadowy u-mar--top--xsml">
				<div className="skeleton__box skeleton__box--raised skeleton__table__box u-padd--sml" />
				{Array.from({ length: 2 }).map((_, i) => (
					<div
						key={i}
						className="skeleton__box skeleton__table__box u-padd--sml"
					/>
				))}
				<div className="skeleton__box skeleton__box--raised skeleton__table__box u-padd--sml" />
				{Array.from({ length: 2 }).map((_, i) => (
					<div
						key={i}
						className="skeleton__box skeleton__table__box u-padd--sml"
					/>
				))}
			</div>
			<TransactionTableSkeletonLoader />
		</>
	);
}
